import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import {filterSingle_multiLevel_selector_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSingle_multiLevel_selector_template";
import {sidebarMenu_template} from "../templates/sidebarMenu_template";

declare var ko: any;

export class usersList_template extends vnTemplate{

    protected filter: filterSimple_template;
    public pagination: pagination_template;
    public roleFilter: filterSingle_multiLevel_selector_template;
    public sidebarMenu: sidebarMenu_template;


    protected getTemplateHtml(): string{

        return `

        <div class="page-header">
            <button data-bind="event: { click: openSidebar }" class="button-default no-text icon i-hamburger preferences no-after"></button>
            <h2 style="display: none;" class="title-page">Users</h2>
        </div>

        <div class="nav-page-container">

            <div class="nav-page-grid">
                <div class="nav-page-sidebar" data-bind="visible: $data.sidebarMenu.isVisible()">
                    ` + this.sidebarMenu.getHtmlBuild() + `
                </div>
                <div class="nav-page-content">

                    <div class="block-default variation">
                        <div class="w-justify full-width">
                            <div class="w-left w-form">
                                <div class="form-body form-body-header">
                                    <div class="form-group">
                                        <span class="form-sub-title">
                                            Manage user access to your account
                                        </span>
                                    </div>
                                    <div class="form-group">
                                        <p class="form-text">
                                            Add new users, update their details, or assign roles to control permissions. Use the search and filtering options to find specific users quickly.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="w-right">

                            </div>
                        </div>
                    </div>


                        <div class="w-justify block-filters">
                            <div class="w-right flex-all block-default">
                                <div class="w-justify full-width">
                                    <div class="w-left">
                                        <div class="default-group row">
                                            <label class="form-label" for="" >Role</label>` + this.roleFilter.getHtmlBuild()  +`
                                        </div>
                                    </div>
                                    <div class="w-right">

                                    </div>
                                </div>
                            </div>
                        </div>



                        <div class="list-header w-justify list-results-header">

                            <div class="w-left">
                                <button data-bind="click: onClickAdd, visible: permissions()['user_edit_advanced'].write" class="button-default icon i-add-2" type="button">Add user</button>
                            </div>

                            <div class="w-center">
                                ` + this.filter.getHtmlBuild() + `
                            </div>

                            <div class="w-right">
                                `+ this.pagination.getHtmlBuild() +`
                            </div>

                        </div>

                        <div class="w-list-results taller" id="list-results">

                            <table class="list-results">
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th class="align-right"><span data-bind="event: {click: onReorderTableData.bind(this, $data, 'firstName')}, css: {'i-sort-up': tableOrdering().col == 'firstName' && tableOrdering().dir == 'ASC', 'i-sort-down': tableOrdering().col == 'firstName' && tableOrdering().dir == 'DESC'}" class="icon icon i-sort">First Name</span></th>
                                        <th><span data-bind="event: {click: onReorderTableData.bind(this, $data, 'lastName')}, css: {'i-sort-up': tableOrdering().col == 'lastName' && tableOrdering().dir == 'ASC', 'i-sort-down': tableOrdering().col == 'lastName' && tableOrdering().dir == 'DESC'}" class="icon icon i-sort">Last Name</span></th>
                                        <th><span data-bind="event: {click: onReorderTableData.bind(this, $data, 'loginName')}, css: {'i-sort-up': tableOrdering().col == 'loginName' && tableOrdering().dir == 'ASC', 'i-sort-down': tableOrdering().col == 'loginName' && tableOrdering().dir == 'DESC'}" class="icon icon i-sort">User</span></th>
                                        <th><span data-bind="event: {click: onReorderTableData.bind(this, $data, 'email')}, css: {'i-sort-up': tableOrdering().col == 'email' && tableOrdering().dir == 'ASC', 'i-sort-down': tableOrdering().col == 'email' && tableOrdering().dir == 'DESC'}" class="icon icon i-sort">Mail</span></th>
                                        <th><span data-bind="event: {click: onReorderTableData.bind(this, $data, 'dateCreation')}, css: {'i-sort-up': tableOrdering().col == 'dateCreation' && tableOrdering().dir == 'ASC', 'i-sort-down': tableOrdering().col == 'dateCreation' && tableOrdering().dir == 'DESC'}" class="icon icon i-sort">Created</span></th>
                                    </tr>
                                </thead>

                                <tbody data-bind="foreach: users">

                                    <tr class="cursor" data-bind="event: { click: $parent.onClickView }">
                                        <td>
                                            <div class="w-img"><img data-bind="attr:{src: pictureUrl}" alt=""></div>
                                        </td>
                                        <td><span data-bind="text: firstName"></span></td>
                                        <td><span data-bind="text: lastName"></span></td>
                                        <td><span data-bind="text: loginName"></span></td>
                                        <td><span data-bind="text: email"></span></td>
                                        <td><span data-bind="text: dateCreation"></span></td>
                                    </tr>

                                </tbody>
                            </table>
                        </div>

                </div>
            </div>
        </div>

        <footer class="default-footer">
            <span class="logo-short"></span>
            <span class="footer-text">©${new Date().getFullYear()} ValServ Inc. All rights reserved.</span>
            <span>|</span>
            <a href="https://sentinelpro.com/pages/privacy-policy" target="_blank">Privacy Policy</a>
        </footer>

        <div class="w-lightbox light-theme ">
                <div class="lightbox-content">

                    <div class="w-form lightbox-form">
                        <div class="form-header">
                            <h3 class="form-title">Add User</h3>
                            <button type="button" class="close-button icon i-close-2"></button>
                        </div>

                        <div class="form-body">
                            <div class="form-group">

                            </div>
                        </div>

                        <div class="form-footer">
                            <button type="button" class="btn">Cancel</button>
                            <button type="button" class="btn highlight">Add</button>
                        </div>
                    </div>

                </div>
            </div>


            `;
    }

    protected initPartial(): void {

        this.sidebarMenu = new sidebarMenu_template("sidebarMenu", this.getTemplateViewModel(), this.caller);
        this.sidebarMenu.setPageSelected('account-users');

        this.filter = new filterSimple_template("filter", this.getTemplateViewModel(), this.caller);
        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 25;
        this.roleFilter = new filterSingle_multiLevel_selector_template("roleFilter", this.getTemplateViewModel(), this.caller)
    }

    protected getTemplateName(): string{

        return "usersList-template";
    }

    protected getMainElementType(): string{

        return "div";
    }

    protected getMainElementClasses(): Array<string>{
    	return ["page-content"];
    }

    protected buildViewModel(): any{

        // define the viewmodel data/ functions
        let self = this;
        return  {
            users: ko.observableArray([ ]),
            isEarningsVisible: ko.observable(false),
            isRoleFilterVisible: ko.observable(false),
            permissions: ko.observableArray(self.initPermissions(['user_edit_advanced'])),
            tableOrdering: ko.observable({ col: null, dir: null }),
            onReorderTableData: function(data, column){

                self.reorderTableData(data, column)
            },
            onClickView : function(data, event){ self.onClickView(data.id); },
            onClickEdit : function(data, event){ self.onClickEdit(data.id); },
            onClickEarnings : function(data, event){ self.onClickEarnings(data.id); },
            onClickAdd : function(){ self.onClickAdd(); },
            openSidebar: function(){ self.openSidebar(); }
        };
    }


    public reorderTableData(data, column){

        const currentOrdering = this.getTemplateViewModel().tableOrdering();

        if(currentOrdering.col == null || currentOrdering.col != column) {

            this.getTemplateViewModel().tableOrdering({ col: column, dir: 'DESC'});
        } else if(currentOrdering.col == column && currentOrdering.dir == 'DESC') {

            this.getTemplateViewModel().tableOrdering({ col: column, dir: 'ASC' });
        } else {

            this.getTemplateViewModel().tableOrdering({ col: null, dir: null });
        }

        this.caller.userListReorder();
    }

    //
    // implementation of base class [vnTemplate]
    public getViewModelForRequest(){

        return {
            filter : this.getTemplateViewModel().filter
            ,pagination: this.getTemplateViewModel().pagination
            ,roleFilterId: this.roleFilter.getTemplateViewModel().selectedOption() ? this.roleFilter.getTemplateViewModel().selectedOption().toString().replace('_', '') : null
            ,roleFilterText:  this.roleFilter.getTemplateViewModel().selectedOptionText()
            ,tableOrdering: this.getTemplateViewModel().tableOrdering()
        }
    }

    public setSideMenuPermissionsData(data){

        this.sidebarMenu.setData(data);
    }

    public onClickView(id){

        this.caller.viewUserProfile(id);
    }

    public onClickEdit(id){

        this.caller.editUser(id);
    }

    public onClickEarnings(id){

        this.caller.earningsUser(id);
    }

    public onClickAdd(){

        this.caller.addUser();
    }

    public setUsers(users: Array<{pictureUrl: string ,fullName: string ,loginName: string ,email: string ,dateCreation : string}>): void{

        this.getTemplateViewModel().users(users);
    }

    public setRoleFilterVisible(isRoleFilterVisible: boolean){

        this.getTemplateViewModel().isRoleFilterVisible(isRoleFilterVisible);
    }

    public setPermissions(permissions){

        this.getTemplateViewModel().permissions(permissions);
    }

    private openSidebar(){

        this.sidebarMenu.setSidebarToggle(true);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/usersList_template.ts